import { TBlockchain } from 'src/types';
import { ReactComponent as BitcoinLogo } from 'src/assets/icons/bitcoin_logo.svg';
import { ReactComponent as EthereumLogo } from 'src/assets/icons/eth_logo.svg';
import { ReactComponent as ArbitrumLogo } from 'src/assets/icons/arbitrum_logo.svg';
import { ReactComponent as TronLogo } from 'src/assets/icons/tron_logo.svg';
import { ReactComponent as BaseLogo } from 'src/assets/icons/base-logo.svg';

export const chainIconMap: Record<
  TBlockchain,
  React.FC<{ className?: string }>
> = {
  bitcoin: BitcoinLogo,
  ethereum: EthereumLogo,
  arbitrum: ArbitrumLogo,
  tron: TronLogo,
  base: BaseLogo,
};
